import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {},
    isLogin: false,
  },
  mutations: {
    changeLogin(state, newStatus) {
      state.isLogin = newStatus;
    },
    changeUserInfo(state, newState) {
      state.userInfo = newState;
    },
  },
  actions: {},
  modules: {},
});
